const Select = () => (
  <>
    <path
      fill="currentColor"
      d="m9.55 15.88 8.802-8.801a.5.5 0 0 1 .344-.156.47.47 0 0 1 .363.156.5.5 0 0 1 .166.357.5.5 0 0 1-.166.356l-8.943 8.95a.78.78 0 0 1-.566.242.78.78 0 0 1-.565-.242l-4.05-4.05a.484.484 0 0 1 .006-.713.5.5 0 0 1 .356-.166q.192 0 .357.166z"
    />
  </>
)
export default Select
